const headerEl = document.querySelector('.product-selector__header');
const header = headerEl.querySelector('span');
const items = document.querySelectorAll('.product-selector__item');
const selectorTitle = headerEl.getAttribute('data-selector-title') || 'Martini Flavor';

const originalText = header.textContent;

items.forEach(item => {
    item.addEventListener('mouseenter', () => {
        const flavorName = item.getAttribute('data-value');
        header.textContent = `${selectorTitle}: ${flavorName}`;
    });
    
    item.addEventListener('mouseleave', () => {
        header.textContent = originalText;
    });
});